import React from 'react';
import Icon from './Icon';

export default class IconExport extends Icon {

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
        return (
            <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 14 14">
                <path fill={color}
                      d="M10.345 4.807H8.251v1.235h2.094c.623 0 1.106.316 1.106.589v5.477c0 .273-.483.589-1.106.589H2.428c-.622 0-1.106-.316-1.106-.589V6.631c0-.272.484-.589 1.106-.589h2.094V4.807H2.428C1.111 4.807.08 5.608.08 6.631v5.478c0 1.022 1.031 1.823 2.348 1.823h7.918c1.316 0 2.348-.8 2.348-1.823V6.63c0-1.023-1.032-1.824-2.349-1.824z"/>
                <path fill={color}
                      d="M4.548 3.079c.159 0 .318-.06.44-.181l.777-.773v6.284a.62.62 0 0 0 .622.617.62.62 0 0 0 .621-.617V2.083l.82.815a.621.621 0 0 0 .879 0 .615.615 0 0 0 0-.873L6.85.18A.62.62 0 0 0 6.412 0H6.403a.62.62 0 0 0-.44.18L4.109 2.026a.615.615 0 0 0 0 .873c.122.12.28.181.44.181z"/>
            </svg>
        )
    }
}